import { render, staticRenderFns } from "./StockTransactionDelete.vue?vue&type=template&id=f56ae1e8&"
import script from "./StockTransactionDelete.vue?vue&type=script&lang=js&"
export * from "./StockTransactionDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports